module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAAAAXNSR0IArs4c6QAAAP5JREFUWAnt1zsOwjAMANAGwU04Wj8DLAxwhooZhibclCHYEpW8xCX+SAzJ0jR2kidXStuua61VgK9A4MN8NOccUko3zBqG4R5CyPyMcnRfDm1HYoxXyJoxE/pHgI1SzG57OzbjTaI9YCJWiYz93BVNoqsvy/KA+xMZe43QaiujhiDAAmMCscCYQbQYU4gGYw6RYlwgEowbpBbjCqnBaE9W3Itt0zSdIeFJkvr1/UTGOncI3Yzr/82jcYXUHP1ukBoEPjIXSC3CBSJBmEOkCFOIBmEG0SJMIBYIhKhOVkBcYA3196oaAgsccJFvE300r5NV54jlD9YKatdWgVIFPvq+mgPOCUfwAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Arrow.png
// module id = 1yhh
// module chunks = 0